/* global axios */
import ApiClient from './ApiClient';

class CrmContacts extends ApiClient {
  constructor() {
    super('crm_contacts', { accountScoped: true });
  }

  // slây thông tin crm
  search(phoneSearch) {
    return axios.get(`${this.url}/search`, { params: { phoneSearch } });
  }

  getBillHistory(maKhach) {
    return axios.get(`${this.url}/bill_history`, { params: { maKhach } });
  }

  getBookingHistory(maKhach) {
    return axios.get(`${this.url}/booking_history`, { params: { maKhach } });
  }

  getNotes(maKhach) {
    return axios.get(`${this.url}/list_note`, { params: { maKhach } });
  }

  checkLink(maKhach) {
    return axios.get(`${this.url}/check_link`, { params: { maKhach } });
  }

  getProductStats(idKhach) {
    return axios.get(`${this.url}/product_stats`, { params: { id: idKhach } });
  }

  createGuest(data) {
    return axios.post(`${this.url}/create_guest`, data);
  }

  createNote(data) {
    return axios.post(`${this.url}/create_note`, data);
  }

  getVouchers(dienThoai) {
    return axios.get(`${this.url}/vouchers`, { params: { dienThoai } });
  }

  updateGuest(data) {
    return axios.post(`${this.url}/update_guest`, data);
  }

  getGuest(id) {
    return axios.get(`${this.url}/get_guest`, { params: { id } });
  }

  get(options = {}, customUrl = null) {
    const requestUrl = customUrl || this.url;
    return axios.get(requestUrl, options);
  }
}

export default new CrmContacts();
